import BillingAgencyRepository from '../../../domain/user/profile/BillingAgencyRepository';
import BillingAgency from '../../../domain/user/profile/BillingAgency';

export default class HardcodedBillingAgencyRepository implements BillingAgencyRepository {
  listAll(): BillingAgency[] {
    return [new BillingAgency('Médyx', 'AGP-68076'), new BillingAgency('Sylvie Le Breux', 'AGP-64301')];
  }
}
